<template>
  <div>
    <Header/>
    <Section id="intro" class="intro">
      <div class="wrapper">
        <h1>{{ $t("section.intro.title")}}</h1>
        <p>{{ $t("section.intro.content")}}</p>
      </div>
    </Section>
    <Section class="features">
      <Feature icon="cercle01" :text="$t('section.features.feature_1')"/>
      <Feature icon="cercle02" :text="$t('section.features.feature_2')"/>
      <Feature icon="cercle03" :text="$t('section.features.feature_3')"/>
    </Section>
    <Section id="contact" class="contact">
      <img alt="cercle04" src="./assets/images/cercle04.png">
      <h2>{{ $t('section.contact.tagline') }}</h2>
      <ContactLink :title="$t('section.contact.button')"/>
    </Section>
    <Footer/>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Section from "./components/Section.vue";
import Footer from "./components/Footer.vue";
import Feature from "./components/Feature.vue";
import ContactLink from "./components/ContactLink.vue";

export default {
  name: "app",
  components: {
    Header,
    Section,
    Footer,
    Feature,
    ContactLink
  }
};
</script>

<style>
html {
  box-sizing: border-box;
  font-size: 16px;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

ol,
ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

@font-face {
  font-family: "Alef";
  src: url("./assets/fonts/Alef-Regular.ttf");
}
@font-face {
  font-family: "Alef";
  src: url("./assets/fonts/Alef-Bold.ttf");
  font-weight: bold;
}

body {
  color: #00c8b7;
  font-family: "Alef";
  font-size: 12px;
}

section {
  min-height: 500px;
}

section.intro {
  color: #fff;
  background-color: #4595ee;
  background-image: linear-gradient(to bottom right, #4595ee, #00fe79);
  padding-top: 5em;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
}

section.intro .wrapper {
  width: 50%;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
}

section.intro .wrapper h1 {
  font-size: 4em;
  font-weight: bold;
  margin-bottom: 0.5em;
}

section.intro .wrapper p {
  font-size: 2em;
}

section.features {
  background: #d9f7f4;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
}

section.contact {
  background: #fff;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

section.contact img {
  max-width: 40%;
}

section.contact h2 {
  font-size: 3.5em;
  font-weight: bold;
}

@media only screen and (max-width: 800px) {
  body {
    font-size: 10px;
  }

  section.intro .wrapper {
    width: 80%;
  }

  section.features {
    flex-flow: column wrap;
    padding-top: 5em;
  }
}
</style>
